import type { TrigKey } from './keys';

export const th: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'คณิตศาสตร์ · ตรีโกณมิติ',
  'panel.experiment': 'การทดลอง',
  'panel.params': 'พารามิเตอร์',
  'panel.scene': 'เลือกการทดลอง',
  'experiment.right-triangle.label': 'สามเหลี่ยมมุมฉาก',
  'experiment.unit-circle.label': 'วงกลมหนึ่งหน่วย',
  'experiment.wave-studio.label': 'สตูดิโอคลื่น',
  'experiment.identity-playground.label': 'เอกลักษณ์',
  'experiment.triangle-solver.label': 'แก้สามเหลี่ยม',
  'experiment.circular-polar.label': 'วงกลม & เชิงขั้ว',
  'hint.line1': 'ลากจุด เลื่อนแถบ',
  'hint.line2': 'เนื้อหาการเรียนรู้อยู่ในเรขาคณิต ไม่ใช่ตัวอักษร',
  'rt.angle.a': 'มุม A',
  'rt.angle.b': 'มุม B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'เรเดียน',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'สแนป 30°/45°/60°',
  'uc.units': 'หน่วย',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'แสดง ASTC',
  'uc.snap.common': 'สแนปมุมที่ใช้บ่อย',
  'uc.angle.value': '∠',
  'uc.units.deg': 'องศา',
  'uc.units.rad': 'rad',
  'uc.units.both': 'องศา+rad',
  'ws.fn': 'ฟังก์ชัน',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — แอมพลิจูด',
  'ws.frequency': 'B — ความถี่',
  'ws.phase': 'C — เลื่อนเฟส',
  'ws.shift': 'D — เลื่อนแนวตั้ง',
  'ws.rform.toggle': 'รูป R',
  'ws.rform.a': 'a (สัมประสิทธิ์ sin)',
  'ws.rform.b': 'b (สัมประสิทธิ์ cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'รีเซ็ต',
  'ws.base': 'แสดงเส้นโค้งพื้นฐาน',
  'ip.id.pythagorean': 'พีทาโกรัส',
  'ip.id.reciprocal': 'ส่วนกลับ',
  'ip.id.quotient': 'ผลหาร',
  'ip.id.sum': 'ผลรวม',
  'ip.id.difference': 'ผลต่าง',
  'ip.id.double': 'มุมสองเท่า',
  'ip.id.half': 'ครึ่งมุม',
  'ip.play': 'เล่น',
  'ip.pause': 'หยุด',
  'ip.step': 'ขั้น',
  'ip.reset': 'รีเซ็ต',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'ใน v2 — การพิสูจน์นี้ต้องการการสร้างที่ละเอียดกว่า',
  'ts.area': 'พื้นที่',
  'ts.sineRule': 'กฎไซน์',
  'ts.cosineRule': 'กฎโคไซน์',
  'ts.ambiguous.toggle': 'แสดงสามเหลี่ยมเงา',
  'ts.reset': 'รีเซ็ตเป็นด้านเท่า',
  'ts.snap.integers': 'สแนปจำนวนเต็ม',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'ด้าน',
  'ts.section.angles': 'มุม',
  'ts.section.sineRule': 'กฎไซน์',
  'ts.section.cosineRule': 'กฎโคไซน์',
  'ts.section.area': 'พื้นที่',
  'cp.omega': 'ความเร็วเชิงมุม',
  'cp.plot.y': 'พล็อต y (sin)',
  'cp.plot.x': 'พล็อต x (cos)',
  'cp.polar.label': 'รูปเชิงขั้ว',
  'cp.polar.circle': 'วงกลม (r = 1)',
  'cp.polar.rose': 'กุหลาบ (r = sin 3θ)',
  'cp.polar.cardioid': 'หัวใจ (r = 1 + cos θ)',
  'cp.polar.limacon': 'ลิมาซง (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'มุมเล็ก (sin x ≈ x)',
  'cp.play': 'เล่น',
  'cp.pause': 'หยุด',
  'cp.reset': 'รีเซ็ต',
  'cp.step': 'ขั้น π/12',
};
